module.exports = __webpack_public_path__ + "static/media/soundSquirrel.92e4fc2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/soundSquirrel.jpg
// module id = 1130
// module chunks = 4